module.exports = __webpack_public_path__ + "img/exportURL2.5f844cf4.png";